<template>
  <div class="main">
    <a-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
    >
      <div class="margin">
        <!--<div class="header">-->
        <span class="title" style="font-size: 30px !important;">megaWms</span>
        <!--</div>-->
        <a-tabs
          :activeKey="customActiveKey"
          :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset',margin: '20px'}"
          @change="handleTabClick"
        >
          <a-tab-pane key="tab1" :tab="$t('tab.loginTab')">
            <!--<a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" message="账户或密码错误（admin/ant.design )" />-->
            <a-form-item class="login-form-item">
              <a-input
                v-decorator="[
                  'username',
                  {rules: [{ required: true, message: $t('message.pleaseInputAccount') }, { validator: handleUsernameOrEmail }], validateTrigger: 'change'}
                ]"
                :placeholder="$t('placeholder.account')"
                size="large"
                type="text"
                class="ant-input"
              >
                <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="user"/>
              </a-input>
            </a-form-item>

            <a-form-item class="login-form-item">
              <a-input
                size="large"
                type="password"
                autocomplete="false"
                :placeholder="$t('placeholder.password')"
                class="ant-input "
                v-decorator="[
                  'password',
                  {rules: [{ required: true, message: $t('message.pleaseInputPassword') }], validateTrigger: 'blur'}
                ]"
              >
                <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="lock"/>
              </a-input>
            </a-form-item>
          </a-tab-pane>
          <!--<a-tab-pane key="tab2" tab="手机号登录">-->
          <!--<a-form-item>-->
          <!--<a-input size="large" type="text" placeholder="手机号" v-decorator="['mobile', {rules: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号' }], validateTrigger: 'change'}]">-->
          <!--<a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }"/>-->
          <!--</a-input>-->
          <!--</a-form-item>-->

          <!--<a-row :gutter="16">-->
          <!--<a-col class="gutter-row" :span="16">-->
          <!--<a-form-item>-->
          <!--<a-input size="large" type="text" placeholder="验证码" v-decorator="['captcha', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">-->
          <!--<a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>-->
          <!--</a-input>-->
          <!--</a-form-item>-->
          <!--</a-col>-->
          <!--<a-col class="gutter-row" :span="8">-->
          <!--<a-button-->
          <!--class="getCaptcha"-->
          <!--tabindex="-1"-->
          <!--:disabled="state.smsSendBtn"-->
          <!--@click.stop.prevent="getCaptcha"-->
          <!--v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')"-->
          <!--&gt;</a-button>-->
          <!--</a-col>-->
          <!--</a-row>-->
          <!--</a-tab-pane>-->
        </a-tabs>

        <!--        <a-form-item>-->
        <!--          <a-checkbox style="color: #1890ff;" v-decorator="['rememberMe']">记住密码</a-checkbox>-->
        <!--          &lt;!&ndash;<router-link&ndash;&gt;-->
        <!--          &lt;!&ndash;:to="{ name: 'recover', params: { user: 'aaa'} }"&ndash;&gt;-->
        <!--          &lt;!&ndash;class="forge-password"&ndash;&gt;-->
        <!--          &lt;!&ndash;style="float: right;"&ndash;&gt;-->
        <!--          &lt;!&ndash;&gt;忘记密码</router-link>&ndash;&gt;-->
        <!--        </a-form-item>-->

        <a-form-item style="margin-top:24px">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            :loading="state.loginBtn"
            :disabled="state.loginBtn"
          >{{$t('button.login')}}
          </a-button>
        </a-form-item>
      </div>
    </a-form>

    <two-step-captcha
      v-if="requiredTwoStepCaptcha"
      :visible="stepCaptchaVisible"
      @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"
    />
  </div>
</template>

<script>
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
import { getSmsCaptcha } from '@/api/login'
import Vue from 'vue'
import { ACCESS_TOKEN, ENTERPRISE, OPERATOR, WAREHOUSE } from '@/store/mutation-types'

export default {
  components: {
    TwoStepCaptcha
  },
  data() {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        loginType: 0,
        smsSendBtn: false
      },
      no: '',
      user: {}
    }
  },
  created() {
    // get2step({ })
    //   .then(res => {
    //     this.requiredTwoStepCaptcha = res.result.stepCode
    //   })
    //   .catch(() => {
    //     this.requiredTwoStepCaptcha = false
    //   })
    // this.requiredTwoStepCaptcha = true
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      // this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey,
        Login
      } = this
      state.loginBtn = true
      Vue.ls.remove(ACCESS_TOKEN)
      const validateFieldsKey = customActiveKey === 'tab1' ? ['username', 'password'] : ['mobile', 'captcha']
      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          const loginParams = { ...values }
          delete loginParams.username
          loginParams[!state.loginType ? 'email' : 'username'] = values.username
          loginParams.password = values.password //md5(values.password)
          loginParams.appname = 'DESKTOP'

          Vue.ls.set(OPERATOR, null)
          const param = {}
          param.username = values.username
          param.login = true

          Login(loginParams)
            .then((res) => {
              if (res.success) {
                this.loginSuccess()
              }
            })
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    getCaptcha(e) {
      e.preventDefault()
      const { form: { validateFields }, state } = this
      validateFields(['mobile'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true
          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading('验证码发送中..', 0)
          getSmsCaptcha({ mobile: values.mobile }).then(res => {
            setTimeout(hide, 2500)
            this.$notification['success']({
              message: '提示',
              description: '验证码获取成功，您的验证码为：' + res.result.captcha,
              duration: 8
            })
          }).catch(err => {
            setTimeout(hide, 1)
            clearInterval(interval)
            state.time = 60
            state.smsSendBtn = false
          })
        }
      })
    },
    stepCaptchaSuccess(res) {
      this.loginSuccess(res)
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    loginSuccess(res) {
      const operator = Vue.ls.get(OPERATOR)
      if (operator.warehouses.length > 1) {
        this.$router.push({ name: 'warehouseSelect' }, () => {
          this.$message.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`
          })
        })
      } else {
        Vue.ls.set(ENTERPRISE, { id: operator.enterprise.id })
        Vue.ls.set(WAREHOUSE, operator.warehouses[0])
        this.$router.push({ name: 'statistics' }, () => {
          this.$message.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`
          })
        })
      }
      this.isLoginError = false
    }
  }
}
</script>

<style lang="less" scoped>
/* 登录容器 */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(to right, #3498db, #2c3e50);
  background-size: cover;
  position: relative;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: -1;
}

/* 登录表单 */
.main {
  width: 400px;
  background: rgba(255, 255, 255, 0.8);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.title {
  display: block;
  text-align: center;
  font-size: 50px;
  color: #1890ff;
  font-weight: bold;
}

/* 登录输入框统一样式 */
.ant-input {
  border-radius: 8px;
  background: #f0f0f0;
  transition: all 0.3s ease;
  margin-bottom: 20px; /* 确保间距一致 */
  position: relative;
}

//.login-form-item{
//  border-color: #1890ff;
//  box-shadow: 0 0 10px rgba(24, 144, 255, 0.5);
//}
/* 前缀图标样式 */
.ant-input .ant-input-prefix {
  color: rgba(0, 0, 0, 0.25);
}
/* 标签样式 */
.ant-tabs {
  margin-bottom: 20px;
}

.ant-tabs-bar {
  .ant-tabs-tab {
    color: #666;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .ant-tabs-tab-active {
    color: #1890ff;
    font-weight: bold;
  }
}

/* 登录按钮 */
.login-button {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  background: linear-gradient(to right, #1890ff, #007bff);
  transition: all 0.3s ease;
}

.login-button:hover {
  background: #1890ff;
}

.login-button:active {
  background: #005cbf;
}

/* 错误提示 */
.ant-form-item-explain {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

</style>
